import { Root, createRoot } from 'react-dom/client';
import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'Intl/Intl';
import { store } from '_common/redux';

class ReactUtils {
  static renderReactComponent(component: ReactNode, root: Root) {
    root.render(
      <Provider store={store}>
        <IntlProvider locale={store.getState().intl.locale}>{component}</IntlProvider>
      </Provider>,
    );
  }

  static renderReactComponentWithoutRedux(component: ReactNode, root: Root) {
    root.render(component);
  }

  static createReactRoot(container: HTMLElement) {
    return createRoot(container);
  }

  static unmountReactComponent(root?: Root) {
    if (!root) {
      return;
    }
    setTimeout(() => {
      root.unmount();
    }, 0);
  }
}

export default ReactUtils;
